const primaryMain = '#7A2426';
const primaryMainOpacity = 'rgba(122, 36, 38, 0.9)';
const secondaryMain = '#D6430A';
const secondaryMainOpacity = 'rgba(214, 67, 10, 0.5)';
const secondaryLight = '#A6192D';
const tertiaryMain = '#3B0006';

export const palette = {
  primaryMain,
  primaryMainOpacity,
  primaryText: primaryMain,
  secondaryMain,
  secondaryMainOpacity,
  secondaryLight,
  secondaryText: secondaryMain,
  tertiaryMain,
  formNavBar: {
    currentStepButtonTextColor: tertiaryMain
  }
};
